// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".screenHome[data-v-5d80ec1b] {\n  min-height: calc(100vh - 45px - 35px - 20px);\n}", ""]);
// Exports
module.exports = exports;
